import api from "@services/api";
import mixpanel from "@utils/mixpanel/mixpanel.js";

function getIceReports(confirmed = 0) {
  return api.get(`/dashboard/ice_reports/${confirmed}`);
}

function updateIceReport(id, data) {
  return api.put(`/dashboard/ice_reports/${id}`, data);
}

function deleteIceReport(id) {
  return api.delete(`/dashboard/ice_reports/${id}`);
}
function createIceReport(data) {
  return api.post(`/dashboard/ice_reports`, data);
}
const dashboardService = {
  getIceReports,
  updateIceReport,
  deleteIceReport,
  createIceReport,
};

export default dashboardService;
